/**
 * Direct Access (DA) role configurations.
 *
 * DA Therapists: All 5 population types share identical config
 * DA Supervisors: All 5 share identical config
 */

import { DA_THERAPIST_CALENDAR } from './calendars'
import { RoleConfig } from './types'

/**
 * DA Therapist configuration.
 * Used by: DA_COUPLES, DA_FAMILY, DA_INDIVIDUAL, DA_CHILD, DA_ADOLESCENT therapists
 *
 * Note: videoSessionsEnabled is set to false by default but can be overridden
 * via the isDAEngageOnOffPlatformVideoEnabled LaunchDarkly flag during login.
 * Recording is always disabled for DA therapists regardless of flag state.
 */
export const DA_THERAPIST: RoleConfig = {
  sameDayBooking: false,
  bcPlatform: true,
  showOOOMessageTab: true,
  videoSessionsEnabled: false,
  recordingDisabled: true,
  medicationEnabled: false,
  zendeskWidget: true,
  requestPayment: true,
  directAccessClientList: true,
  eligibilityChecker: true,
  paymentHistory: true,
  oldClientsList: true,
  utilizationEnabled: false,
  showMinifiedUtilization: false,
  showOverdueMessageFlag: false,
  showInPersonPrompt: true,
  smartSchedulingEnabled: true,
  hidePerformanceMetrics: true,
  hideTodoPage: true,
  showCloseSessionBanner: false,
  reducedActivitiesExperience: true,
  programColumnHeader: 'Care Type',
  inProductCalendar: DA_THERAPIST_CALENDAR,
  showCareInsights: false,
  useNewDashboard: true,
  supportsOnOffPlatformVideo: true,
  showCalendarCapacity: true,
}

/**
 * DA Supervisor configuration.
 * Used by: DA_INDIVIDUAL, DA_FAMILY, DA_COUPLES, DA_CHILD, DA_ADOLESCENT supervisors
 */
export const DA_SUPERVISOR: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: true,
  assessmentTrackSettingsEnabled: true,
  inProductCalendar: DA_THERAPIST_CALENDAR,
}
